import { mapToCamelCase, mapToSnakeCase } from '@consigli/utils';
import { z } from 'zod';
import { documentPackageSchema } from './document-package';
import { findingCommentSchema } from './finding-comment';
import { languageSchema } from './language';
import { getPaginationResponseSchema } from './pagination';
import { ProcessorName } from './processor-name';
import { projectSchema } from './project';
export var FindingStatus;
(function (FindingStatus) {
    FindingStatus["NOT_RELEVANT"] = "NOT_RELEVANT";
    FindingStatus["ACTIVE"] = "ACTIVE";
    FindingStatus["PROCESSING"] = "PROCESSING";
    FindingStatus["PROCESSED"] = "PROCESSED";
    FindingStatus["DELETED"] = "DELETED";
})(FindingStatus || (FindingStatus = {}));
export var ScheduleCheckType;
(function (ScheduleCheckType) {
    ScheduleCheckType["MISSING"] = "MISSING";
    ScheduleCheckType["PARTIAL"] = "PARTIAL";
    ScheduleCheckType["COMPLETE"] = "COMPLETE";
})(ScheduleCheckType || (ScheduleCheckType = {}));
export var ConflictCategory;
(function (ConflictCategory) {
    ConflictCategory["RISK"] = "RISK";
    ConflictCategory["INSIGHT"] = "INSIGHT";
    ConflictCategory["PROPERTY"] = "PROPERTY";
    ConflictCategory["COMPANY"] = "COMPANY";
    ConflictCategory["RENTAL_AGREEMENT"] = "RENTAL_AGREEMENT";
    ConflictCategory["MISSING_DOCUMENTATION"] = "MISSING_DOCUMENTATION";
    // Bid Review (Offer): gaps between a bid and the tender (PARTIAL / MISSING).
    ConflictCategory["GAPS"] = "GAPS";
})(ConflictCategory || (ConflictCategory = {}));
export var ConflictType;
(function (ConflictType) {
    ConflictType["REFERENCE_ERROR_BUILDING_PART_TABLE"] = "REFERENCE_ERROR_BUILDING_PART_TABLE";
    ConflictType["REFERENCE_ERROR_STANDARD"] = "REFERENCE_ERROR_STANDARD";
    ConflictType["REFERENCE_ERROR_STANDARD_DELETED"] = "REFERENCE_ERROR_STANDARD_DELETED";
    ConflictType["CHECKLIST"] = "CHECKLIST";
    ConflictType["OTHER_LANGUAGE"] = "OTHER_LANGUAGE";
    ConflictType["PRODUCT_SPECIFICATION"] = "PRODUCT_SPECIFICATION";
    ConflictType["UNCLEAR_WORDING"] = "UNCLEAR_WORDING";
    ConflictType["INCORRECT_WORDING"] = "INCORRECT_WORDING";
    ConflictType["PROJECT_RECOMMENDATION"] = "PROJECT_RECOMMENDATION";
    ConflictType["RECOMMENDATIONS"] = "RECOMMENDATIONS";
    ConflictType["RISK_INDUCING_TEXT"] = "RISK_INDUCING_TEXT";
    ConflictType["MISSING_REQUIREMENTS"] = "MISSING_REQUIREMENTS";
    ConflictType["SIMILAR_PARAGRAPH"] = "SIMILAR_PARAGRAPH";
    ConflictType["IDENTICAL_SENTENCE"] = "IDENTICAL_SENTENCE";
    ConflictType["TIME_PERIODS"] = "TIME_PERIODS";
    ConflictType["DEADLINES"] = "DEADLINES";
    ConflictType["UNDEFINED_DEADLINES"] = "UNDEFINED_DEADLINES";
    ConflictType["CONTRADICTIONS"] = "CONTRADICTIONS";
    ConflictType["FORMATTING"] = "FORMATTING";
    ConflictType["DEVIATION_PRODUCT_NAME"] = "DEVIATION_PRODUCT_NAME";
    ConflictType["PRICES"] = "PRICES";
    ConflictType["RESPONSIBILITY"] = "RESPONSIBILITY";
    ConflictType["REFERENCE_ERROR"] = "REFERENCE_ERROR";
    ConflictType["RESERVATIONS_AND_CLARIFICATIONS"] = "RESERVATIONS_AND_CLARIFICATIONS";
    ConflictType["DISCLAIMERS"] = "DISCLAIMERS";
    ConflictType["UNDEFINED_REQUIREMENTS"] = "UNDEFINED_REQUIREMENTS";
    ConflictType["CORPORATE_LAW_CONDITIONS"] = "CORPORATE_LAW_CONDITIONS";
    ConflictType["INFORMATION_SERVICE_AGREEMENT"] = "INFORMATION_SERVICE_AGREEMENT";
    ConflictType["INFORMATION_RENTAL_AGREEMENT"] = "INFORMATION_RENTAL_AGREEMENT";
    ConflictType["RISK_LEASE_AGREEMENT"] = "RISK_LEASE_AGREEMENT";
    ConflictType["DEVIATION_FROM_STANDARD_LEASE_AGREEMENT"] = "DEVIATION_FROM_STANDARD_LEASE_AGREEMENT";
    ConflictType["PROPERTY_RELATIONS"] = "PROPERTY_RELATIONS";
    ConflictType["TECHNICAL_INFORMATION"] = "TECHNICAL_INFORMATION";
    ConflictType["ENCUMBRANCES"] = "ENCUMBRANCES";
    ConflictType["REGULATORY_CONDITIONS"] = "REGULATORY_CONDITIONS";
    ConflictType["IMPROVEMENTS"] = "IMPROVEMENTS";
    ConflictType["REFERENCE_ERROR_STANDARD_ALT"] = "REFERENCE_ERROR_STANDARD_ALT";
    ConflictType["DEVIATION_CERTIFICATION"] = "DEVIATION_CERTIFICATION";
    ConflictType["DUPLICATED_DOCUMENTS"] = "DUPLICATED_DOCUMENTS";
    ConflictType["DOCUMENT_REFERENCES"] = "DOCUMENT_REFERENCES";
    ConflictType["SPECIFICATION_REQUIREMENTS"] = "SPECIFICATION_REQUIREMENTS";
    ConflictType["PROJECT_RECOMMENDATION_ALT"] = "PROJECT_RECOMMENDATION_ALT";
    ConflictType["LIMITATIONS_OF_LIABILITY"] = "LIMITATIONS_OF_LIABILITY";
    ConflictType["DURABILITY_PRODUCTS"] = "DURABILITY_PRODUCTS";
    ConflictType["OPERATIONAL_INFORMATION"] = "OPERATIONAL_INFORMATION";
    ConflictType["MAINTENANCE_INTERVAL"] = "MAINTENANCE_INTERVAL";
    ConflictType["SERVICE_AGREEMENT"] = "SERVICE_AGREEMENT";
    ConflictType["DEVIATION_INDOOR_REQUIREMENTS"] = "DEVIATION_INDOOR_REQUIREMENTS";
    ConflictType["DEVIATION_SOUND_REQUIREMENTS"] = "DEVIATION_SOUND_REQUIREMENTS";
    ConflictType["DEVIATION_CEILING_TYPE"] = "DEVIATION_CEILING_TYPE";
    ConflictType["COMPLAINT_RULES"] = "COMPLAINT_RULES";
    ConflictType["LIFESPAN_AND_DURABILITY"] = "LIFESPAN_AND_DURABILITY";
    ConflictType["SERVICE_AGREEMENT_RECOMMENDATION"] = "SERVICE_AGREEMENT_RECOMMENDATION";
    ConflictType["SERVICE_AGREEMENT_NECESSARY"] = "SERVICE_AGREEMENT_NECESSARY";
    ConflictType["SERVICE_AGREEMENT_AGREED"] = "SERVICE_AGREEMENT_AGREED";
    ConflictType["WARRANTY_CONDITIONS"] = "WARRANTY_CONDITIONS";
    ConflictType["WORKING_DRAWINGS"] = "WORKING_DRAWINGS";
    ConflictType["MISSING_DOCUMENTATION"] = "MISSING_DOCUMENTATION";
    ConflictType["UNDEFINED_CLEANING_INTERVALS"] = "UNDEFINED_CLEANING_INTERVALS";
    ConflictType["CLEANING_INTERVALS"] = "CLEANING_INTERVALS";
    ConflictType["WARRANTY_PERIOD"] = "WARRANTY_PERIOD";
    ConflictType["UNDEFINED_MAINTENANCE_INTERVAL"] = "UNDEFINED_MAINTENANCE_INTERVAL";
    ConflictType["DEVIATION_GENERAL_SPECIFICATIONS"] = "DEVIATION_GENERAL_SPECIFICATIONS";
    ConflictType["DEVIATION_ORG_NR"] = "DEVIATION_ORG_NR";
    ConflictType["LAWSUITS_AND_DISPUTES"] = "LAWSUITS_AND_DISPUTES";
    ConflictType["KEY_INFORMATION"] = "KEY_INFORMATION";
    ConflictType["GROUND_CONDITIONS"] = "GROUND_CONDITIONS";
    ConflictType["ENVIRONMENT"] = "ENVIRONMENT";
    ConflictType["GOVERNING_INTEREST"] = "GOVERNING_INTEREST";
    ConflictType["HISTORY"] = "HISTORY";
    ConflictType["DELETED_ORG"] = "DELETED_ORG";
    ConflictType["BANKRUPT_ORG"] = "BANKRUPT_ORG";
    ConflictType["ORGANIZATION_DISSOLUTION"] = "ORGANIZATION_DISSOLUTION";
    ConflictType["RENTAL_AGREEMENTS_OF_PROPERTY"] = "RENTAL_AGREEMENTS_OF_PROPERTY";
    ConflictType["ATTACHED_RENTAL_AGREEMENTS"] = "ATTACHED_RENTAL_AGREEMENTS";
    ConflictType["TRANSPORTED_RENTAL_AGREEMENTS"] = "TRANSPORTED_RENTAL_AGREEMENTS";
    ConflictType["MISSING_OM_DOCUMENTATION"] = "MISSING_OM_DOCUMENTATION";
    ConflictType["SIMILAR_PARAGRAPH_ALT"] = "SIMILAR_PARAGRAPH_ALT";
    ConflictType["DUPLICATED_REQUIREMENTS"] = "DUPLICATED_REQUIREMENTS";
    ConflictType["UNRESOLVED_ISSUES"] = "UNRESOLVED_ISSUES";
    ConflictType["MISSING_DRAWINGS"] = "MISSING_DRAWINGS";
    ConflictType["MISSING_CALLOUT"] = "MISSING_CALLOUT";
    ConflictType["MISSING_DETAIL"] = "MISSING_DETAIL";
    ConflictType["MISSING_INDEX"] = "MISSING_INDEX";
    ConflictType["MISSING_DRAWING_NAME_IN_INDEX"] = "MISSING_DRAWING_NAME_IN_INDEX";
    ConflictType["MISSING_TITLE"] = "MISSING_TITLE";
    ConflictType["MISSING_REVISION"] = "MISSING_REVISION";
    ConflictType["MISSING_INFORMATION"] = "MISSING_INFORMATION";
    ConflictType["MISSING_SCHEMATIC_DRAWINGS"] = "MISSING_SCHEMATIC_DRAWINGS";
    ConflictType["CONTRACT_TERMINOLOGY"] = "CONTRACT_TERMINOLOGY";
    ConflictType["DATES"] = "DATES";
    ConflictType["DEFICIENT_FUNCTIONAL_DESCRIPTIONS"] = "DEFICIENT_FUNCTIONAL_DESCRIPTIONS";
    ConflictType["EXCEPTIONS"] = "EXCEPTIONS";
    ConflictType["CLEANING_INSTRUCTIONS"] = "CLEANING_INSTRUCTIONS";
    ConflictType["IRREGULAR_TIME_PERIOD"] = "IRREGULAR_TIME_PERIOD";
    ConflictType["DEVIATION_ELECTRO_OG_AUTOMATION"] = "DEVIATION_ELECTRO_OG_AUTOMATION";
    ConflictType["DEVIATION_BATHROOM"] = "DEVIATION_BATHROOM";
    ConflictType["IDENTICAL_PARAGRAPH"] = "IDENTICAL_PARAGRAPH";
    ConflictType["SUGGESTED_FILENAME"] = "SUGGESTED_FILENAME";
    ConflictType["CONTRADICTIONS_OM"] = "CONTRADICTIONS_OM";
    ConflictType["CONTRADICTIONS_ENERGY_PERFORMANCE"] = "CONTRADICTIONS_ENERGY_PERFORMANCE";
    ConflictType["CONTRADICTION_TRIAL_PERIOD"] = "CONTRADICTION_TRIAL_PERIOD";
    ConflictType["FORCE_MAJEURE"] = "FORCE_MAJEURE";
    ConflictType["DEVIATION_FROM_STANDARD_LEASE_AGREEMENT_ALT"] = "DEVIATION_FROM_STANDARD_LEASE_AGREEMENT_ALT";
    ConflictType["PUBLIC_PROCUREMENT"] = "PUBLIC_PROCUREMENT";
    ConflictType["SITE_RISK"] = "SITE_RISK";
    ConflictType["CONTRACT_RISK"] = "CONTRACT_RISK";
    ConflictType["WITHDRAWN_STANDARD"] = "WITHDRAWN_STANDARD";
    ConflictType["INTERNATIONAL_STANDARD_REFERENCE"] = "INTERNATIONAL_STANDARD_REFERENCE";
    ConflictType["FIRE_SAFETY"] = "FIRE_SAFETY";
    ConflictType["UNCLEAR_WORDING_ALT"] = "UNCLEAR_WORDING_ALT";
    ConflictType["EDITABLE_DOCUMENTS"] = "EDITABLE_DOCUMENTS";
    ConflictType["MILESTONE"] = "MILESTONE";
    ConflictType["DELIVERABLE"] = "DELIVERABLE";
    ConflictType["SCALE_CITATION"] = "SCALE_CITATION";
    ConflictType["MISSING_UNITS"] = "MISSING_UNITS";
    ConflictType["MISSING_SCALE"] = "MISSING_SCALE";
    ConflictType["UNIT_DISPARITY"] = "UNIT_DISPARITY";
    ConflictType["MISSING_COUNTERPART_OR_ORPHAN"] = "MISSING_COUNTERPART_OR_ORPHAN";
    ConflictType["DUPLICATE_IDENTIFIER"] = "DUPLICATE_IDENTIFIER";
    ConflictType["ATTRIBUTE_CONFLICT"] = "ATTRIBUTE_CONFLICT";
    ConflictType["INCOMPLETE_DATA"] = "INCOMPLETE_DATA";
    ConflictType["INCOMPLETE_FUNCTION_OR_ASSEMBLY"] = "INCOMPLETE_FUNCTION_OR_ASSEMBLY";
    ConflictType["CONVENTION_NON_CONFORMANCE"] = "CONVENTION_NON_CONFORMANCE";
    ConflictType["SPECIFICATION_GAP"] = "SPECIFICATION_GAP";
    ConflictType["RATING_EXCEEDANCE"] = "RATING_EXCEEDANCE";
    ConflictType["REVISION_OR_CURRENCY"] = "REVISION_OR_CURRENCY";
    ConflictType["PARTIAL"] = "PARTIAL";
    ConflictType["MISSING"] = "MISSING";
    ConflictType["DEVIATION"] = "DEVIATION";
    ConflictType["ADDRESSED"] = "ADDRESSED";
})(ConflictType || (ConflictType = {}));
export const findingSchema = z
    .object({
    id: z.number().int(),
    project_id: projectSchema.innerType().shape.id,
    document_package_id: documentPackageSchema.innerType().shape.id,
    blob_id: z.string().uuid().nullish(),
    file_name: z.string().nullish(),
    // Generic passthrough of the source blob's `metadata.reference` role tag.
    // Bid Review (Offer) interprets it (contractor / tender / leveling template)
    // in `pages/offer/offer-references.ts`; null for services that don't set it.
    blob_reference: z.string().nullish(),
    content: z.string().nullish(),
    page_number: z.number().int().nullish(),
    status: z.nativeEnum(FindingStatus),
    ref_document_package_id: z.string().uuid().nullish(),
    ref_blob_id: z.string().uuid().nullish(),
    ref_file_name: z.string().nullish(),
    ref_blob_reference: z.string().nullish(),
    ref_content: z.string().nullish(),
    ref_page_number: z.number().int().nullish(),
    processor_name: z.nativeEnum(ProcessorName),
    message_template: z.string(),
    message_context: z.record(z.union([z.string(), z.record(z.unknown()), z.array(z.unknown())])),
    message_context_en: z.record(z.union([z.string(), z.record(z.unknown()), z.array(z.unknown())])),
    conflict_type: z.nativeEnum(ConflictType),
    conflict_category: z.nativeEnum(ConflictCategory),
    x0: z.number().nullish(),
    y0: z.number().nullish(),
    x1: z.number().nullish(),
    y1: z.number().nullish(),
    ref_x0: z.number().nullish(),
    ref_y0: z.number().nullish(),
    ref_x1: z.number().nullish(),
    ref_y1: z.number().nullish(),
    excel_metadata: z
        .object({
        primary: z
            .object({
            sheet_name: z.string(),
            row: z.array(z.number().int()).nullish(),
            col: z.array(z.number().int()).nullish(),
            column_name: z.array(z.string()).nullish(),
        })
            .nullish(),
        ref: z
            .object({
            sheet_name: z.string(),
            row: z.array(z.number().int()).nullish(),
            col: z.array(z.number().int()).nullish(),
            column_name: z.array(z.string()).nullish(),
        })
            .nullish(),
    })
        .nullish(),
    file_url: z.string().nullable(),
    download_url: z.string().nullable(),
    comments: z.array(findingCommentSchema),
    labels: z.array(z.string()).nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const createFindingSchema = findingSchema
    .innerType()
    .omit({
    id: true,
    project_id: true,
    document_package_id: true,
    file_name: true,
    blob_reference: true,
    ref_file_name: true,
    ref_blob_reference: true,
    comments: true,
    file_url: true,
    labels: true,
})
    .extend({
    conflict_message: z.string(),
})
    .strict()
    .transform(mapToSnakeCase);
export const createFindingResponseSchema = findingSchema.transform(mapToCamelCase);
export const getFindingsRequestSchema = z
    .object({
    project_id: z.number().int(),
    package_id: z.string().uuid(),
    page: z.union([z.number().int(), z.literal('all')]),
    page_size: z.number().int().nullish(),
    status: z.nativeEnum(FindingStatus).nullish(),
    demo_view: z.boolean().nullish(),
    conflict_type: z.nativeEnum(ConflictType).nullish(),
    conflict_category: z.nativeEnum(ConflictCategory).nullish(),
    blob_ids: z.array(z.string()).nullish(),
    search: z.string().nullish(),
    language: languageSchema.nullish(),
    processor_name: z.nativeEnum(ProcessorName).nullish(),
    commenters: z.array(z.string()).nullish(),
    labels: z.array(z.string()).nullish(),
    schedule_check_type: z.nativeEnum(ScheduleCheckType).nullish(),
    // Bid Review (Offer): scope findings to a single bid contractor.
    reference: z.string().nullish(),
    // Bid Review (Offer): scope findings to bid documents only (all contractors),
    // resolved server-side instead of listing every bid blob id.
    bid_documents_only: z.boolean().nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const getFindingsResponseSchema = getPaginationResponseSchema(findingSchema);
export const getFindingRequestSchema = z
    .object({
    project_id: z.number().int(),
    package_id: z.string().uuid(),
    finding_id: z.number().int(),
})
    .strict()
    .transform(mapToCamelCase);
export const updateFindingResponseSchema = findingSchema;
export const updateBatchFindingsResponseSchema = z.array(findingSchema).transform(mapToCamelCase);
export const deleteAllFindingsResponseSchema = z.object({ deleted_count: z.number().int() });
export const getFindingsUniqueBlobsRequestSchema = z
    .object({
    project_id: z.number().int(),
    package_id: z.string().uuid(),
    demo_view: z.boolean().nullish(),
    status: z.nativeEnum(FindingStatus).nullish(),
    conflict_type: z.nativeEnum(ConflictType).nullish(),
    conflict_category: z.nativeEnum(ConflictCategory).nullish(),
    commenters: z.array(z.string()).nullish(),
    labels: z.array(z.string()).nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const getFindingsUniqueBlobsResponseSchema = z.array(z
    .object({
    id: z.string(),
    name: z.string(),
})
    .strict()
    .transform(mapToCamelCase));
export const getFindingsConflictTypeCountRequestSchema = z
    .object({
    project_id: z.number().int(),
    package_id: z.string().uuid(),
    demo_view: z.boolean().nullish(),
    blob_ids: z.array(z.string()).nullish(),
    commenters: z.array(z.string()).nullish(),
    labels: z.array(z.string()).nullish(),
    reference: z.string().nullish(),
    bid_documents_only: z.boolean().nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const getFindingsConflictTypeCountResponseSchema = z.record(z
    .object({
    count: z.number().int(),
    subcounts: z.record(z.number().int()),
})
    .strict()
    .transform(mapToCamelCase));
export const getFindingsStatusCountRequestSchema = z
    .object({
    project_id: z.number().int(),
    package_id: z.string().uuid(),
    demo_view: z.boolean().nullish(),
    blob_ids: z.array(z.string()).nullish(),
    conflict_type: z.nativeEnum(ConflictType).nullish(),
    conflict_category: z.nativeEnum(ConflictCategory).nullish(),
    commenters: z.array(z.string()).nullish(),
    labels: z.array(z.string()).nullish(),
    reference: z.string().nullish(),
    bid_documents_only: z.boolean().nullish(),
    processor_name: z.nativeEnum(ProcessorName).nullish(),
    search: z.string().nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const getFindingsStatusCountResponseSchema = z
    .record(z.number().int())
    .transform(mapToCamelCase);
export const getFindingsCommentersRequestSchema = z
    .object({
    project_id: z.number().int(),
    package_id: z.string().uuid(),
    demo_view: z.boolean().nullish(),
    blob_ids: z.array(z.string()).nullish(),
    status: z.nativeEnum(FindingStatus).nullish(),
    conflict_type: z.nativeEnum(ConflictType).nullish(),
    conflict_category: z.nativeEnum(ConflictCategory).nullish(),
    labels: z.array(z.string()).nullish(),
    reference: z.string().nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const findingCommenterSchema = z
    .object({
    id: z.string(),
    name: z.string(),
})
    .strict()
    .transform(mapToCamelCase);
export const getFindingsCommentersResponseSchema = z.array(findingCommenterSchema);
export const getFindingsUniqueLabelsRequestSchema = z
    .object({
    project_id: z.number().int(),
    package_id: z.string().uuid(),
    blob_ids: z.array(z.string()).nullish(),
    demo_view: z.boolean().nullish(),
    status: z.nativeEnum(FindingStatus).nullish(),
    conflict_type: z.nativeEnum(ConflictType).nullish(),
    conflict_category: z.nativeEnum(ConflictCategory).nullish(),
    commenters: z.array(z.string()).nullish(),
    bid_documents_only: z.boolean().nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const getFindingsUniqueLabelsResponseSchema = z.array(z.string());
